import React, { useCallback, useState } from 'react';
import { AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import { toast } from 'react-toastify';
import ConfirmationModal from 'components/Modal/ConfirmationModal';
import ContactService from '../../../services/contactService';
import { InfoRelatedContainer } from './style';
import { PiHouseLineBold } from 'react-icons/pi';
import EditAddressModal from '../EditAddressModal';

const ContactAddress = ({ addresses, contactId, reloadContact }) => {
  const [openModalConfirmation, setOpenModalConfirmation] = useState(false);
  const [idOfAddressToRemove, setIdOfAddressToRemove] = useState(null);

  const formatTitle = useCallback((name = '') => {
    if (name.length <= 26) return name;
    return `${name.substring(0, 24).trim()}...`;
  }, []);

  const handleRemoveAddress = useCallback(
    (id) => {
      ContactService.removeAddressesFromContact(contactId, [id])
        .then(() => {
          toast.success('Endereço removido');
          reloadContact();
        })
        .catch((err) => {
          const message =
            err?.response?.data?.message || 'Erro ao remover endereço';
          toast.error(message);
        })
        .finally(() => {
          setOpenModalConfirmation(false);
          setIdOfAddressToRemove(null);
        });
    },
    [contactId, reloadContact]
  );

  const controlDelete = (id) => {
    setIdOfAddressToRemove(id);
    setOpenModalConfirmation(true);
  };

  if (!addresses || !addresses.length) return null;

  const validAddresses = addresses.filter(
    (address) =>
      address &&
      (address.title ||
        address.cep ||
        address.street ||
        address.city ||
        address.state)
  );

  if (!validAddresses || !validAddresses.length) return null;

  return (
    <>
      <div
        style={{
          display: 'flex',
          gap: '0.5rem',
          flexWrap: 'wrap'
        }}
      >
        {validAddresses.map((address) => (
          <InfoRelatedContainer key={address.id}>
            <div
              style={{
                position: 'absolute',
                right: '0.5rem',
                top: '0.1rem',
                display: 'flex',
                gap: '0.25rem'
              }}
            >
              <EditAddressModal
                contactId={contactId}
                onAddressUpdated={reloadContact}
                contact={null}
                address={address}
                buttonOpenModal={({ onClick }) => (
                  <div
                    style={{ cursor: 'pointer' }}
                    onClick={onClick}
                    title="Editar endereço"
                  >
                    <AiOutlineEdit type="button" size={18} color="#1f69c0" />
                  </div>
                )}
              />
              <div
                style={{ cursor: 'pointer' }}
                onClick={() => controlDelete(address.id)}
                title="Excluir endereço"
              >
                <AiOutlineDelete type="button" size={18} color="#82000b" />
              </div>
            </div>
            <div>
              <span title={address.title}>
                <PiHouseLineBold /> {formatTitle(address.title)}
              </span>
            </div>
            <div className="small">
              <span>
                <span className="font-weight-bold">CEP: </span>
                {address.zipCode || ''}
              </span>
            </div>
            <div className="small">
              <span className="font-weight-bold">Estado: </span>
              <span>{address.state || ''}</span>
            </div>
            <div className="small">
              <span className="font-weight-bold">Cidade: </span>
              <span>{address.city || ''}</span>
            </div>
            <div className="small">
              <span className="font-weight-bold">Bairro: </span>
              <span>{address.neighborhood || ''}</span>
            </div>
            <div className="small">
              <span className="font-weight-bold">Rua: </span>
              <span>{address.street || ''}</span>
            </div>
            <div className="small">
              <span className="font-weight-bold">Número: </span>
              <span>{address.number || 'S/N'}</span>
            </div>
            <div className="small">
              <span className="font-weight-bold">Complemento: </span>
              <span>{address.complement || ''}</span>
            </div>
          </InfoRelatedContainer>
        ))}
      </div>
      <ConfirmationModal
        isModalOpen={openModalConfirmation}
        onModalToggle={setOpenModalConfirmation}
        unmountOnClose={true}
        idResource={idOfAddressToRemove}
        deleteResource={handleRemoveAddress}
        message={'Tem certeza que deseja remover este endereço do contato?'}
      />
    </>
  );
};

export default ContactAddress;
